import { useEffect, useRef, useState } from 'react';

export function formatFirstRechargeCountdown(totalSeconds: number): string {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const seconds = safeSeconds % 60;
  return [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
}

export function useFirstRechargePreview(selectedId: string, active: boolean) {
  const [animatingId, setAnimatingId] = useState('');
  const [appliedId, setAppliedId] = useState('');
  const applyTimer = useRef<number | null>(null);
  const finishTimer = useRef<number | null>(null);

  useEffect(() => {
    if (applyTimer.current) window.clearTimeout(applyTimer.current);
    if (finishTimer.current) window.clearTimeout(finishTimer.current);
    setAnimatingId('');
    setAppliedId('');
    if (!active || !selectedId) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setAppliedId(selectedId);
      return;
    }

    setAnimatingId(selectedId);
    applyTimer.current = window.setTimeout(() => setAppliedId(selectedId), 760);
    finishTimer.current = window.setTimeout(() => setAnimatingId(''), 1350);
    return () => {
      if (applyTimer.current) window.clearTimeout(applyTimer.current);
      if (finishTimer.current) window.clearTimeout(finishTimer.current);
    };
  }, [active, selectedId]);

  return { animatingId, appliedId };
}
